import React, { useEffect, useState } from 'react';
import { View } from 'react-native';
import { registerRootComponent } from 'expo';
import * as SystemUI from 'expo-system-ui';
import { Appearance } from 'react-native';
import { getThemeOverride } from './src/theme/themeOverride';
import { disableFontScaling } from './src/config/disableFontScaling';

// Bloqueo MAGISTRAL del escalado de texto en iOS y Android
// Aplica múltiples estrategias para forzar allowFontScaling=false
disableFontScaling();

// Bootstrap para cargar override de tema ANTES de cargar patch y App
function Bootstrap() {
  const [AppComp, setAppComp] = useState(null);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        // Cargar override persistido y exponer en global
        const ov = await getThemeOverride();
        if (typeof globalThis !== 'undefined') {
          globalThis.__THEME_OVERRIDE__ = ov || null;
        }

        // Establecer fondo nativo para evitar flash blanco/negro
        try {
          const scheme = (ov === 'light' || ov === 'dark') ? ov : (Appearance?.getColorScheme?.() || 'light');
          await SystemUI.setBackgroundColorAsync(scheme === 'dark' ? '#000000' : '#FFFFFF');
        } catch {}

        // NOTA: patchStyleSheet deshabilitado - los componentes ahora usan estilos dinámicos con isDark
        // require('./src/theme/patchStyleSheet');

        // Cargar App dinámicamente después del parche
        const mod = await import('./App');
        if (!mounted) return;
        setAppComp(() => mod.default);
      } catch (e) {
        // fallback: cargar App igualmente
        const mod = await import('./App');
        if (!mounted) return;
        setAppComp(() => mod.default);
      }
    })();
    return () => {
      mounted = false;
    };
  }, []);

  if (!AppComp) return <View style={{ flex: 1, backgroundColor: '#00000000' }} />;
  const Comp = AppComp;
  return <Comp />;
}

registerRootComponent(Bootstrap);
